export const diRegistry = new WeakMap();
export const PACKAGE_NAME = 'react-magnetic-di';